// full list of errors
// https://docs.dataforseo.com/v3/appendix/errors/

export const keywordTaskStatus = {
    notFound: 'Task Not Found.',
    notStarted: 'Task Started.',
    inQueue: 'Task In Queue.',
    ok: 'Ok.',
    error: /[Ee]rror/,
}